import React, { useState } from "react";
import styled from "styled-components";
import { CauseEffectSection } from "./CauseEffectSection";
import { VerticalLineSection } from "./VerticalLineSection";
import { LInkedObjectivesSection } from "./LInkedObjectivesSection";
import { GetHook } from "../../../api/api";
import { OBJECTIVE_URL, SCORECARD_URL } from "../../../api/urls";
import { useParams } from "react-router-dom";

interface IProps {
  scorecard_id: any;
}

export const LinkageSection = ({ scorecard_id }: IProps) => {
  const [primaryObjectiveId, setPrimaryObjectiveID] = useState("");

  const { data: objectives } = GetHook(
    scorecard_id ? `${SCORECARD_URL}/${scorecard_id}/objective` : "null"
  );

  const { data: perspectives } = GetHook(
    scorecard_id ? `${SCORECARD_URL}/${scorecard_id}/perspective` : "null"
  );

  return (
    <LinkageSectionContainer>
      <CauseEffectSection
        data={objectives}
        setPrimaryObjectiveID={setPrimaryObjectiveID}
      />
      <VerticalLineSection />
      <LInkedObjectivesSection
        primaryObjectiveId={primaryObjectiveId}
        scorecard_id={scorecard_id}
        perspectives={perspectives}
      />
    </LinkageSectionContainer>
  );
};
const LinkageSectionContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1px 1.5fr;
`;
